<template>
  <div class="content has-text-centered">
    <table
      class="table is-striped is-responsive"
      :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
      id="getBonus"
    >
      <thead>
        <tr>
          <th>{{$t("trading_account").tUpper()}}</th>
          <th>{{$t("platform").tUpper()}}</th>
          <!-- <th>{{$t("type").tUpper()}}</th> -->
          <th>{{$t("amount").tUpper()}}</th>
          <th>{{$t("date").tUpper()}}</th>
          <th>{{$t("status").tUpper()}}</th>
          <th>{{$t("conversion_progress").tUpper()}}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="bonus in Bonuses"
          :key="bonus.trading_account"
        >
          <td>{{bonus.trading_account}}</td>
          <td>{{bonus.platform}}</td>
          <!-- <td>{{bonus.bonusType}}</td> -->
          <td>{{$formatMoney(bonus.bonusAmount, '')}}</td>
          <td>{{bonus.dateGranted.substring(0, 16).replace("T", " ")}}</td>
          <td>{{bonus.status}}</td>
          <td>
            <div class="bar">
              <div class="progressText">{{Math.floor(bonus.conversion_progress)}}%</div>
              <div
                class="progress"
                :style="'width: '+Math.floor(bonus.conversion_progress)+'%;'"
              ></div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { service } from '../app'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      Bonuses: null,
      bonus: null,
      active: false,
      name: 'Bonus list',
    }
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
    }),
  },
  mounted() {
    this.getBonus()
  },
  methods: {
    getBonus() {
      service.get('/bonus/' + this.User.info.ID).then(response => {
        this.Bonuses = response.data.Bonuses
      })
    },
    submitSearchBonus() {
      this.getBonus()
    },
  },
}
</script>

<style lang="scss" scoped>
#getBonus {
  margin-top: 20px;
}

div.bar {
  position: relative;
  width: 150px;
  height: 20px;
  background-color: #eeffee;
  border-radius: 6px;
  border: solid 1px green;

  div.progress {
    position: absolute;
    height: 18px;
    background-color: #aaffaa;
    border-radius: 6px;
    z-index: 1;
  }
  div.progressText {
    position: absolute;
    width: 150px;
    height: 18px;
    text-align: center;
    z-index: 2;
  }
}
</style>



// WEBPACK FOOTER //
// my-bonuses.vue?36a8dcde